module.exports = __webpack_public_path__ + "static/project-7cab31b1f0b6545b90446f50347ad092.jpg";